import moment from 'moment';
import momentDurationFormatSetup from 'moment-duration-format';

// *: registered here, next to the only formatter that needs it, so the side effect
// *: travels with its consumer instead of sitting in a shared lib barrel.
momentDurationFormatSetup(moment);

/**
 * Renders a numeric duration into a display string using a moment duration format pattern. Builds a moment duration from the value in the given unit (minutes by default) and formats it, passing stopTrim through so leading zero units can be kept.
 *
 * @param duration - Numeric duration value.
 * @param format - Moment duration format pattern to render with.
 * @param stopTrim - Units that must not be trimmed from the formatted output.
 * @param unit - Unit the duration value is expressed in.
 * @returns Formatted duration string.
 */
const getDuration = (duration: any, format: any, stopTrim: any = undefined, unit = 'minutes') =>
  moment.duration(duration, unit as any).format(format, { stopTrim });

export { getDuration };
